module.exports = __webpack_public_path__ + "ea07932c5245dd421e3d05f579098bc2.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/BoldItalic/OpenSans-BoldItalic.eot
// module id = 1008
// module chunks = 0